import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthLink, AuthShell } from "@/components/account/AuthShell";
import { Field, FormError, PasswordField, SubmitButton } from "@/components/account/Field";
import { useAccount } from "@/context/AccountContext";
import { errorMessage } from "@/lib/api";

export default function AccountRegister() {
  const { customer, register } = useAccount();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (customer) return <Navigate to="/account" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) {
      setError("La password deve avere almeno 8 caratteri.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await register(form);
      toast.success("Account creato!", { description: "Ti ho inviato un'email: conferma l'indirizzo per collegare i tuoi ordini." });
      navigate("/account", { replace: true });
    } catch (err) {
      setError(errorMessage(err, "Registrazione non riuscita. Controlla i dati e riprova."));
      setLoading(false);
    }
  };

  return (
    <AuthShell testid="account-register-page" lines={["Entra", "nella crew."]} kicker="Ordini, spedizioni e drop in un unico posto">
      <form onSubmit={submit} className="space-y-6" data-testid="account-register-form">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">Crea il tuo account sfushop</p>
        <Field label="Nome e cognome" required minLength={2} autoComplete="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} testid="account-register-name-input" />
        <Field label="Email" required type="email" autoComplete="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} testid="account-register-email-input" />
        <PasswordField label="Password (min. 8 caratteri)" required autoComplete="new-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} testid="account-register-password-input" />
        <FormError error={error} testid="account-register-error" />
        <SubmitButton loading={loading} testid="account-register-submit-button" loadingText="Creo l'account…">Crea account</SubmitButton>
        <p className="text-xs leading-relaxed text-smoke">
          Creando l&apos;account accetti la <Link to="/condizioni#privacy" className="text-bone/80 underline underline-offset-2 hover:text-acid">Privacy policy</Link>. Gli ordini già fatti con questa email compaiono nel profilo dopo la conferma dell&apos;indirizzo.
        </p>
        <p className="border-t border-line pt-6 text-sm text-bone/70">
          Hai già un account? <AuthLink to="/account/accedi" testid="account-go-login-link">Accedi</AuthLink>
        </p>
      </form>
    </AuthShell>
  );
}
